import { collection, getDocs, limit, orderBy, query, startAfter, where } from 'firebase/firestore';
import { useCallback, useRef, useState } from 'react';
import { db } from '../../../core/services/firebase';

const PAGE_SIZE = 10;

export function useTimeline() {
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const cursorRef = useRef(null);

  const fetchCertificates = useCallback(async (isLoadMore = false) => {
    if (isLoadMore) {
      setLoadingMore(true);
    } else {
      setLoading(true);
    }

    try {
      const constraints = [
        collection(db, 'certificates'),
        where('deletedAt', '==', null),
        orderBy('eventDate', 'desc'),
      ];

      if (cursorRef.current) {
        constraints.push(startAfter(cursorRef.current));
      }
      constraints.push(limit(PAGE_SIZE));

      const snapshot = await getDocs(query(...constraints));
      const docs = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

      if (docs.length < PAGE_SIZE) {
        setHasMore(false);
        cursorRef.current = null;
      } else {
        cursorRef.current = snapshot.docs[snapshot.docs.length - 1];
      }

      setCertificates((prev) => (isLoadMore ? [...prev, ...docs] : docs));
    } catch (err) {
      console.error('Failed to fetch timeline:', err);
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  }, []);

  const loadMore = useCallback(() => {
    if (!loadingMore && hasMore) {
      fetchCertificates(true);
    }
  }, [loadingMore, hasMore, fetchCertificates]);

  return { certificates, loading, loadingMore, hasMore, fetchCertificates, loadMore };
}
